/**
 * ドラッグアンドドロップ・同じリスト内の移動
 */
export const reorder = (
  sourceArray: any,
  startIndex: number,
  endIndex: number
) => {
  const remove = sourceArray.splice(startIndex, 1);
  sourceArray.splice(endIndex, 0, remove[0]);
};

/**
 * ドラッグアンドドロップ・リスト跨ぎの移動
 */
export const moveList = (
  sourceArray: any,
  destinationArray: any,
  startIndex: number,
  endIndex: number
) => {
  const remove = sourceArray.splice(startIndex, 1);
  destinationArray.splice(endIndex, 0, remove[0]);
};
